<template>
  <div class="container-fluid">
    <div class="contents simulator">
      <tab />

      <div class="tab-content" id="pills-tabContent">
        <div
          class="tab-pane fade show active"
          id="pills-1"
          role="tabpanel"
          aria-labelledby="pills-1-tab"
        >
          <div class="paging-box">
            <div>
              {{ $t("text.simulator.current_time") }}
              <span class="date">{{
                $dayjs(new Date()).format("YYYY-MM-DD  HH:mm:ss")
              }}</span>
            </div>
          </div>

          <table class="board table si-list" width="100%" cellspacing="0">
            <thead>
              <tr>
                <th colspan="2" class="bb-1">
                  {{ $t("title.simulator.simulator") }}
                </th>
                <th class="d-none d-lg-table-cell" colspan="5">
                  {{ $t("title.simulator.roundinfo") }}
                </th>
                <th rowspan="2">{{ $t("title.common.status") }}</th>
                <th class="d-none d-lg-table-cell" rowspan="2">
                  {{ $t("title.common.control") }}
                </th>
                <th class="th-arrow">&nbsp;</th>
              </tr>
              <tr>
                <th class="border-b-0">{{ $t("title.common.number") }}</th>
                <th class="border-b-0">{{ $t("title.booking.room_name") }}</th>
                <!-- <th class="d-none d-lg-table-cell">
                  {{ $t("title.common.type") }}
                </th> -->
                <th class="d-none d-lg-table-cell">
                  {{ $t("title.simulator.golfcourse") }}
                </th>
                <th class="d-none d-lg-table-cell">
                  {{ $t("title.simulator.player_count") }}
                </th>
                <th class="d-none d-lg-table-cell">
                  {{ $t("title.simulator.start_time") }}
                </th>
                <th class="d-none d-lg-table-cell">
                  {{ $t("title.simulator.end_time") }}
                </th>
                <th class="d-none d-lg-table-cell">
                  {{ $t("title.common.hole") }}
                </th>
                <th class="th-arrow border-b-0"></th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item, idx) in this.roomList">
                <tr class="btn1" @click="toggle_tr(idx)" :key="idx">
                  <td>{{ item.roomno }}</td>
                  <td class="more pointer" @click="infoModalOpen(idx)">
                    {{ item.roomname }}
                  </td>
                  <!-- <td class="d-none d-lg-table-cell">{{ item.holetype }}</td> -->
                  <td class="d-none d-lg-table-cell">{{ item.coursename }}</td>
                  <td class="d-none d-lg-table-cell">{{ item.playercnt }}</td>
                  <td class="d-none d-lg-table-cell date">
                    {{ item.timezone_starttime | dateformat }}
                  </td>
                  <td class="d-none d-lg-table-cell date">
                    {{ item.timezone_endtime | dateformat }}
                  </td>
                  <td class="d-none d-xxl-table-cell w-1 fs-14" v-if="item.holetype">
                    {{ item.finished_hole | suffix("H") }} /
                    {{ item.holetype | suffix("H") }}
                  </td>
                  <td class="d-none d-xxl-table-cell" v-else>                   
                  </td>
                  <td>{{ item.status | status2 }}</td>
                  <td class="d-none d-lg-table-cell py-1">
                    <button
                      class="btn btn-primary btn-xs"
                      @click="msgModalOpen(idx)"
                    >
                      {{ $t("button.simulator.message") }}
                    </button>
                    <button
                      class="btn btn-outline-secondary btn-xs"
                      @click="roomStop(idx)"
                    >
                      {{ $t("button.simulator.game_stop") }}
                    </button>
                  </td>
                  <td class="td-arrow end">
                    <img
                      src="/img/arrow_none_collapsed.png"
                      :class="{ 'btn-toggle-arrow': view_hide === idx }"
                    />
                  </td>
                </tr>
                <tr
                  class="d-lg-none d-md-tabel-cell"
                  :class="{ show: view_hide === idx }"
                  :key="idx + 'r'"
                  v-if="view_hide === idx"
                >
                  <td class="align-left" colspan="10">
                    <div class="layer1">
                      <!-- <div class="row">
                        <div class="col-4">{{ $t("title.common.type") }}</div>
                        <div class="col-8">{{ item.holetype }}</div>
                      </div> -->
                      <div class="row">
                        <div class="col-4">
                          {{ $t("title.simulator.golfcourse") }}
                        </div>
                        <div class="col-8">{{ item.coursename }}</div>
                      </div>
                      <div class="row">
                        <div class="col-4">
                          {{ $t("title.simulator.player_count") }}
                        </div>
                        <div class="col-8">{{ item.playercnt }}</div>
                      </div>
                      <div class="row">
                        <div class="col-4">
                          {{ $t("title.simulator.start_time") }}
                        </div>
                        <div class="col-8 date">
                          {{ item.timezone_starttime | dateformat }}
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4">
                          {{ $t("title.simulator.end_time") }}
                        </div>
                        <div class="col-8 date">
                          {{ item.timezone_endtime | dateformat }}
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4">
                          {{ $t("title.common.hole") }}
                        </div>
                        <div class="col-8" v-if="item.holetype">
                          {{ item.finished_hole | suffix("H") }} /
                          {{ item.holetype | suffix("H") }}
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4">
                          {{ $t("title.common.control") }}
                        </div>
                        <div class="col-8">
                          <button
                            type="button"
                            class="btn btn-primary btn-xs"
                            @click="msgModalOpen(idx)"
                          >
                            {{ $t("button.simulator.message") }}
                          </button>
                          <button
                            type="button"
                            class="btn btn-outline-secondary btn-xs"
                            @click="roomStop(idx)"
                          >
                            {{ $t("button.simulator.game_stop") }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
          <b-pagination-nav
            :link-gen="linkGen"
            :number-of-pages="page_total"
            v-model="searchData.pageno"
            use-router
            aria-label="Page navigation example"
            class="wrap-1200"
            v-if="page_total > 1"
            first-class="prev"
            prev-class="prev"
            next-class="next"
            last-class="next"
            hide-ellipsis
            limit="10"
          >
            <template #first-text
              ><i class="material-icons"
                >keyboard_double_arrow_left</i
              ></template
            >
            <template #prev-text
              ><i class="material-icons">navigate_before</i></template
            >
            <template #next-text
              ><i class="material-icons">navigate_next</i></template
            >
            <template #last-text>
              <i class="material-icons"> keyboard_double_arrow_right</i>
            </template>
            <template #page="{ page, active }">
              <a v-if="active">{{ page }}</a>
              <a v-else>{{ page }}</a>
            </template>
          </b-pagination-nav>
        </div>
      </div>
    </div>
    <b-modal
      id="exampleModal2"
      ref="info-modal"
      centered
      scrollable
      footer-class="btn-bottom-wrapper"
    >
      <template #modal-header="{ close }">
        <h5 class="modal-title">
          {{ $t("page.simulator.simulator_Information") }}
        </h5>
        <b-button
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="close()"
        ></b-button>
      </template>
      <div class="row g-0 border-bottom border-top-dgray">
        <div class="col-sm row g-0 align-items-center bg-gray">
          <label class="d-table-cell">{{ $t("title.common.number") }}</label>
        </div>
        <div class="col-sm">
          <p class="d-table-cell">{{ infoModalObj.roomno }}</p>
        </div>
      </div>
      <div class="row g-0 border-bottom">
        <div class="col-sm row g-0 align-items-center bg-gray">
          <label class="d-table-cell">{{
            $t("title.booking.room_name")
          }}</label>
        </div>
        <div class="col-sm">
          <input
            type="text"
            class="form-control-xl"
            v-model="infoModalObj.roomname"
          />
        </div>
      </div>
      <div class="row g-0 border-bottom">
        <div class="col-sm row g-0 align-items-center bg-gray">
          <label class="d-table-cell">{{
            $t("title.simulator.simulator_code")
          }}</label>
        </div>
        <div class="col-sm">
          <p class="d-table-cell">{{ infoModalObj.code }}</p>
        </div>
      </div>
      <div class="row g-0 border-bottom">
        <div class="col-sm row g-0 align-items-center bg-gray">
          <label class="d-table-cell">{{
            $t("title.simulator.installation_date")
          }}</label>
        </div>
        <div class="col-sm">
          <p class="d-table-cell">
            {{ infoModalObj.timezone_regdate | dateformat }}
          </p>
        </div>
      </div>
      <div class="row g-0 border-bottom">
        <div class="col-sm row g-0 align-items-center bg-gray">
          <label class="d-table-cell">{{ $t("title.common.status") }}</label>
        </div>
        <div class="col-sm">
          <select v-model="infoModalObj.status" @change="infoStatusChange">
            <option value="1">{{ $t("filter.simulator.used") }}</option>
            <option value="2">{{ $t("filter.simulator.unused") }}</option>
            <!-- <option value="3">Using</option> -->
          </select>
        </div>
      </div>
      <div class="row g-0 border-bottom">
        <div class="col-sm row g-0 align-items-center bg-gray">
          <label class="d-table-cell">{{
            $t("title.simulator.simulator_model")
          }}</label>
        </div>
        <div class="col-sm">
          <p class="d-table-cell">{{ infoModalObj.model }}</p>
        </div>
      </div>
      <div class="row g-0 border-bottom">
        <div class="col-sm row g-0 align-items-center bg-gray">
          <label class="d-table-cell">{{
            $t("title.simulator.simulator_version")
          }}</label>
        </div>
        <div class="col-sm">
          <p class="d-table-cell">{{ infoModalObj.version }}</p>
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button
          size="md"
          variant="outline-secondary"
          aria-label="cancel"
          @click="cancel()"
          >{{ $t("button.common.cancel") }}</b-button
        >
        <b-button
          size="md"
          variant="secondary"
          aria-label="save"
          @click="roomSave"
          >{{ $t("button.common.save") }}</b-button
        >
      </template>
      <!--       <template #modal-footer="{ cancel }">
        <b-button
          size="md"
          type="button"
          class="btn-primary btn2"
          @click="roomSave"
        >
          저장
        </b-button>
        <b-button
          size="md"
          type="button"
          class="btn-outline-secondary btn2"
          @click="cancel()"
        >
          취소
        </b-button>
      </template> -->
    </b-modal>
    <b-modal
      ref="msg-modal"
      id="exampleModal1"
      centered
      scrollable
      footer-class="btn-bottom-wrapper"
    >
      <template #modal-header="{ close }">
        <h5 class="modal-title">{{ $t("button.simulator.message") }}</h5>
        <b-button
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="close()"
        ></b-button>
      </template>

      <div class="input-group">
        <input type="text" class="form-control-lg" v-model="msgModalMsg" />
        <small class="info-check">{{
          $t("text.membership.this_message_is_sent_when_loading_a_shot")
        }}</small>
      </div>
      <template #modal-footer="{}">
        <b-button
          size="md"
          variant="secondary"
          aria-label="보내기"
          @click="roomMsgSend"
          >{{ $t("button.simulator.msg_send") }}</b-button
        >
      </template>
      <!--       <template #modal-footer>
        <b-button
          type="button"
          class="btn-primary btn-md btn1"
          @click="roomMsgSend"
        >
          보내기
        </b-button>
      </template> -->
    </b-modal>
  </div>
</template>

<script>
import { utils } from "@/mixin/utils";
import "@/filter/common";
import ax from "@/api/room";
import _ from "lodash";
import tab from "@/components/room/Tab";

export default {
  name: "RoomList",
  components: {
    tab,
  },
  mixins: [utils],
  data() {
    return {
      searchData: {
        searchdate: this.$dayjs(new Date()).format("YYYY-MM-DD"),
        pageno:
          this.$route.query.pageno ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pageno) ||
          1,
        pagesize: 10,
      },
      page_total: 1,
      total_cnt: 0,
      roomList: [],
      infoModalObj: {
        roomno: null,
        roomname: null,
        code: null,
        regdate: null,
        status: null,
        model: null,
        version: null,
      },
      msgModalRoomNo: "",
      msgModalMsg: "",
      view_hide: null,
    };
  },
  created() {
    this.init();
  },
  watch: {
    "searchData.pageno": function () {
      this.init();
    },
  },
  methods: {
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    init() {
      ax.roomList(this.searchData, (data) => {
        this.roomList = data.roomlist;
        this.roomlistcnt = data.roomlistcnt;

        this.total_cnt = data.roomlistcnt;
        this.page_total = Math.ceil(
          data.roomlistcnt / this.searchData.pagesize
        );
        // if (data) {

        // }
      });
    },
    infoModalOpen(idx) {
      let roomno = this.roomList[idx].roomno;
      ax.roomInfo(roomno, (data) => {
        if (data) {
          this.infoModalObj = data;
          this.$refs["info-modal"].modalOuterStyle.zIndex = 9999;
          this.$refs["info-modal"].show();
        }
      });
    },
    roomSave() {
      ax.roomSave(this.infoModalObj, (flag, data) => {
        alert(data.message);
        if (flag) {
          this.$refs["info-modal"].modalOuterStyle.zIndex = 9999;
          this.$refs["info-modal"].hide();
        }
        this.init();
      });
    },
    infoStatusChange() {
      ax.roomStatusChange(this.infoModalObj, (flag, data) => {
        if (flag) {
          this.$notify({
            group: "info",
            type: "warn",
            title: "Notice",
            text: this.$i18n.t("text.room.changed"),
          });
        }
        this.init();
      });
    },
    msgModalOpen(idx) {
      if (this.roomList[idx].status != "1") {
        alert(this.$i18n.t("alert.room.current_system_not_available"));
        return false;
      }

      if (!this.roomList[idx].gameno) {
        alert(this.$i18n.t("alert.room.system_not_currently_in_progress"));
        return false;
      }

      this.msgModalRoomNo = this.roomList[idx].roomno;
      this.$refs["msg-modal"].show();
    },
    roomMsgSend() {
      if (!this.msgModalMsg) {
        alert(this.$i18n.t("alert.room.enter_your_message"));
        return;
      }
      ax.roomMsgInsert(this.msgModalRoomNo, this.msgModalMsg, (flag, data) => {
        alert(data.message);
        if (flag) {
          this.$refs["msg-modal"].hide();
        }
        this.init();
      });
    },
    roomStop(idx) {
      if (
        confirm(
          this.$i18n.t("alert.room.current_game_will_be_exit") +
            "\n" +
            this.$i18n.t("alert.room.do_you_want_proceed")
        )
      ) {
        if (this.roomList[idx].status != "1") {
          alert(this.$i18n.t("alert.room.current_system_not_available"));
          return false;
        }

        if (!this.roomList[idx].gameno) {
          alert(this.$i18n.t("alert.room.system_not_currently_in_progress"));
          return false;
        }
        let roomNo = this.roomList[idx].roomno;
        let gameNo = this.roomList[idx].gameno;
        ax.roomStop(roomNo, gameNo, (flag, data) => {
          alert(data.message);
          if (flag) {
            this.$refs["msg-modal"].hide();
          }
          this.init();
        });
      }
    },
    toggle_tr(idx) {
      if (this.view_hide === idx) this.view_hide = null;
      else this.view_hide = idx;
    },
  },
};
</script>
